var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7076 6.71251C15.0958 7.10343 15.0951 7.73506 14.7055 8.12461L11.5365 11.2937C11.1463 11.6839 11.1459 12.3165 11.5357 12.7071L14.7063 15.8846C15.0952 16.2743 15.0948 16.9053 14.7055 17.2946V17.2946C14.316 17.6842 13.6843 17.6842 13.2948 17.2946L8.70726 12.7071C8.31674 12.3166 8.31674 11.6834 8.70726 11.2929L13.2905 6.70961C13.682 6.31811 14.3175 6.31963 14.7076 6.71251V6.71251Z",
    fill: "#2F2F2F",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPer);
export default __webpack_public_path__ + "static/media/per.8aaea4c67209cc433659d2add1cfd0e6.svg";
export { ForwardRef as ReactComponent };